import React, { Component } from 'react';

import { APIHandler, ExhibitionUsers } from 'C4';
import { HashLink as Link } from 'react-router-hash-link';

import 'react-toastify/dist/ReactToastify.css';

export default class ExhibitionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stands: [],
    };
  }

  componentWillMount() {
    this.getStandsAndFloor();
  }

  getStandsAndFloor() {
    APIHandler.getExhibitionStands(715).then((res) => {
      this.setState({ stands: res });
      const standIds = [];
      Object.values(res).map((item) => {
        Object.values(item.tiles).map((tile) => {
          if (tile.company_id) {
            standIds.push(tile.company_id);
          }
        });
      });
    });
  }

  render() {
    const { stands } = this.state;
    const params = new URLSearchParams(window.location.search);
    const categories = Object.values(stands).map((item) => {
      const icon = item.icon.replace('fa-', '');
      const title = `${item.title}`;
      const url = item.title.replace(/ /g, '-').toLowerCase();
      return (
        <ExhibitionUsers
          buttonIcon={icon}
          buttonPosition={url}
          buttonColor={item.color}
          title={title}
          url={url}
          stands={item.tiles}
          id={item.id}
          key={item.id}
        />
      );
    });
    return (
      <div className='exhibitionFloor mapFloor'>
        <div className='gradient' />

        <div className='exhibition__container'>
        {params.get("header") === 'false' && (
          <div class="contentHeader" id="contentHeader">
            <h3>Hotel Spotlights</h3>
            <h6>The following properties are featured hotels. For a complete list of Leading Hotels, <a href="webview:https://travpromobile-lhw.netlify.app/main/directory/?header=false&mobile=true">click here</a>.</h6>
            <hr />
          </div>)}

          {params.get("header") !== 'false' && (
            <div class="contentHeader" id="contentHeader">
              <h3>Hotel Spotlights</h3>
              <h6>The following properties are featured hotels. For a complete list of Leading Hotels, <Link to="/main/directory">click here</Link>.</h6>
              <hr />
            </div>)}

          <img className='bgMap' src="https://front.travpromobile.com/697/world-map-2.png" />
          {categories}
        </div>
        {params.get("header") === 'false' && (
          <style>
            {
              "\
        .header { display: none; } .northern-europe { top: calc(56% - 25rem) !important; } .southern-europe { top: calc(56% - 5rem) !important; } .western-europe { top: calc(56% - 15rem) !important; } .eastern-europe-and-russia { top: calc(56% - 15rem) !important; } .middle-east { top: 59% !important; } .asia-pacific { top: 58% !important; } .caribbean { top: calc(57% + 4rem) !important; } .north-america { top: 55% !important; } .exhibitionFloor .exhibition__container { margin-top: -15rem !important; } @media (max-width: 760px) { .mapFloor .contentHeader { top: 12rem !important; width: 90% !important; padding-bottom: 10rem; } .mapFloor .contentHeader h6 { padding-left: 0; margin-left: 0; } .mapFloor .contentHeader h3 { padding-left: 0; margin-left: 0; } }"
            }
          </style>
        )}
      </div>
    );
  }
}
